
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/contact/corporation",
      function () {
        return require("private-next-pages/en/contact/corporation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/contact/corporation"])
      });
    }
  